import AdminListHousesScreen from './AdminListHousesScreenContainer';
export default AdminListHousesScreen;
